import { useEffect, useState } from "react";
import {
  Card,
  Box,
  Typography,
  Button,
  Divider,
  Avatar,
  FormControlLabel,
  FormGroup,
  Switch,
} from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import EditDivisionDetails from "./edit-division-details/edit-division-details";
import EditContactDetails from "./edit-contact-details/edit-contact-details";
import ContactLayout from "../../../../../../components/contact-layout/contact-layout";
import DivisionDeactivate from "./division-deactivate/division-deactivate";
import DivisionActivate from "./division-activate/division-activate";

export default function DivisionDetails({
  data,
  clientId,
  onAddDivision,
}: any) {
  const [status, setStatus] = useState(false);
  const [primaryDivisionManager, setPrimaryDivisionManager] = useState<any>();
  const [nonPrimaryDivisionManager, setNonPrimaryDivisionManager] =
    useState<any>([]);
  const [showEditDivision, setShowEditDivision] = useState(false);
  const [showEditContact, setShowEditContact] = useState(false);
  const [showDivisionDeactivate, setShowDivisionDeactivate] = useState(false);
  const [showDivisionActivate, setShowDivisionActivate] = useState(false);

  useEffect(() => {
    if (data) {
      setStatus(data.isActive);

      const filterPrimaryDivisionManager = data?.divisionManagers.filter(
        (divisionManager: any) => divisionManager.isPrimary === true
      );
      const filterNonPrimaryDivisionManager = data?.divisionManagers.filter(
        (divisionManager: any) => divisionManager.isPrimary === false
      );
      setPrimaryDivisionManager(filterPrimaryDivisionManager[0]);
      setNonPrimaryDivisionManager(filterNonPrimaryDivisionManager);
    }
  }, [data]);

  const handleSwitchChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const isActive = event.target.checked;
    // setStatus(isActive);
    if (isActive === false) {
      setShowDivisionDeactivate(true);
    } else {
      setShowDivisionActivate(true);
    }
  };

  return (
    <>
      <Card className="card-layout">
        <Box className="card-header">
          <Typography variant="h5">Division Details</Typography>
          <Button
            variant="text"
            startIcon={<EditOutlinedIcon />}
            onClick={() => setShowEditDivision(true)}
          >
            Edit
          </Button>
        </Box>
        <Box className="display-name-layout">
          <Typography className="label-txt">Status</Typography>
          <FormGroup>
            <FormControlLabel
              control={
                <Switch checked={status} onChange={handleSwitchChange} />
              }
              label={status ? "Active" : "Inactive"}
            />
          </FormGroup>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Division Name</Typography>
          <Typography>{data?.displayName}</Typography>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Division Website</Typography>
          <Box display={"flex"} alignItems={"center"}>
            {data?.website ? (
              <>
                <Typography color="primary">{data?.website}</Typography>
                <Button>
                  <OpenInNewOutlinedIcon color="primary" />
                </Button>
              </>
            ) : (
              <> - </>
            )}
          </Box>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Division Logo</Typography>
          <Avatar
            className="user-avater"
            alt={data?.displayName}
            variant="circular"
            src={data?.logoUrl}
          />
        </Box>
      </Card>

      <Card className="card-layout">
        <Box className="card-header">
          <Typography variant="h5">Contact Details</Typography>
          <Button
            variant="text"
            startIcon={<EditOutlinedIcon />}
            onClick={() => setShowEditContact(true)}
          >
            Edit
          </Button>
        </Box>
        <Box className="user-name-layout">
          <Typography className="label-txt">Division Manager</Typography>
          <Box>
            {primaryDivisionManager ? (
              <ContactLayout data={primaryDivisionManager} isPrimary={true} />
            ) : (
              <> - </>
            )}
            {nonPrimaryDivisionManager.map((divisionManager: any) => (
              <ContactLayout
                key={divisionManager.userId}
                data={divisionManager}
                isPrimary={false}
              />
            ))}
          </Box>
        </Box>
      </Card>

      {showEditDivision && (
        <EditDivisionDetails
          showDialog={showEditDivision}
          closeDialog={() => setShowEditDivision(false)}
          data={data}
          clientId={clientId}
          onAddDivision={onAddDivision}
        />
      )}

      {showEditContact && (
        <EditContactDetails
          showDialog={showEditContact}
          closeDialog={() => setShowEditContact(false)}
          data={data}
          clientId={clientId}
        />
      )}

      {showDivisionDeactivate && (
        <DivisionDeactivate
          showDialog={showDivisionDeactivate}
          closeDialog={() => setShowDivisionDeactivate(false)}
          id={data?.id}
          clientId={clientId}
        />
      )}

      {showDivisionActivate && (
        <DivisionActivate
          showDialog={showDivisionActivate}
          closeDialog={() => setShowDivisionActivate(false)}
          id={data?.id}
          clientId={clientId}
        />
      )}
    </>
  );
}
